var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTheme } from '@citrus/user';
import SelectBase from './private/subcomponents/InputSelectBase';
/** DISPLAY NAME: &lt;Select.Employee&gt; */
function SelectEmployee(_a) {
    var _b = _a.rowHeight, rowHeight = _b === void 0 ? 48 : _b, props = __rest(_a, ["rowHeight"]);
    var isCitron = useTheme().citrus2022;
    rowHeight = isCitron ? 56 : rowHeight;
    return React.createElement(SelectBase, __assign({ rowHeight: rowHeight }, props, { __isEmployee: true }));
}
SelectEmployee.defaultProps = {
    primaryKey: 'id',
    searchKeys: [['preferredFirstName', 'lastName'], ['firstName', 'lastName'], 'title'],
    __TYPE: 'SelectEmployee',
};
export default SelectEmployee;
